'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PromizeText = function (_React$Component) {
    _inherits(PromizeText, _React$Component);

    function PromizeText(props) {
        _classCallCheck(this, PromizeText);

        var _this = _possibleConstructorReturn(this, (PromizeText.__proto__ || Object.getPrototypeOf(PromizeText)).call(this, props));

        _this.repeatUploadedImageTop = { '3/4': 2048, '3/8': 1020, '5/8': 950, '1': 920 };

        _this.pzGetFontColor = function () {
            var pzFontColor = _this.state.settings.background_color;
            if (_this.props.pzActiveOptions && Object.keys(_this.props.pzActiveOptions).length > 0) {
                // Object.keys(props.pzActiveOptions).map((objKey, index) => {
                for (var objKey in _this.props.pzActiveOptions) {
                    var currActionOptions = _this.props.pzActiveOptions[objKey];
                    var findIdxDyesub = currActionOptions.findIndex(function (element) {
                        return typeof element === "string" && element.indexOf('dyesub') !== -1;
                    });
                    if (findIdxDyesub >= 0) {
                        pzFontColor = _this.props.pzDyesubTextDefaultColor;
                        break;
                    }
                }
                //console.log("pzFontColor 123 => ", pzFontColor)
                return pzFontColor;
            }
            //console.log("pzFontColor", pzFontColor)
            return pzFontColor;
        };

        _this.handleClickOutside = function (event) {
            if (!event.target.classList.contains('active')) {
                _this.setState({ 'showFontSize': false, showFont: false, showFontColorForMobile: false, showFontStyleForMobile: false, showFontAlignForMobile: false });
            }
        };

        _this.pzDefaultProperties = function (pzTexts) {
            var pzTextDetail = pzTexts.promize_attribute_text_value;
            var textSetting = _this.props.pzCustomizer.attributeDomainTexts;
            var pzTextSetting = {};
            var pzFontColor = _this.pzGetFontColor();
            pzTextSetting['fontFamily'] = pzTextDetail.default_font_family ? textSetting['fontFamilies'][pzTextDetail.default_font_family].font_name : 'Arial';
            pzTextSetting['fontFamilyFile'] = pzTextDetail.default_font_family ? textSetting['fontFamilies'][pzTextDetail.default_font_family].font_file : 'Arial.tiff';
            pzTextSetting['fontSize'] = pzTextDetail.default_font_size ? textSetting['fontSizes'][pzTextDetail.default_font_size].font_size : 70;
            pzTextSetting['fill'] = pzTextDetail.default_color ? pzFontColor : '#000';
            pzTextSetting['textAlign'] = pzTextDetail.default_text_align ? textSetting['textAligns'][pzTextDetail.default_text_align].text_align_name : 'center';
            pzTextSetting['fontWeight'] = pzTextDetail.default_font_shape ? textSetting['fontShapes'][pzTextDetail.default_font_shape].font_shape_name : 'normal';
            pzTextSetting['fontStyle'] = 'normal'; //pzTextDetail.default_text_align ? textSetting['textAligns'][pzTextDetail.default_text_align].text_align_name : 'center';
            pzTextSetting['text'] = '';
            if (_this.props.pzCanvasObject['FObject_text_' + pzTexts.promize_tab_attribute_id + '_0']) {
                pzTextSetting['fontFamily'] = _this.props.pzCanvasObject['FObject_text_' + pzTexts.promize_tab_attribute_id + '_0'].fontFamily;
                pzTextSetting['fontFamilyFile'] = _this.props.pzCanvasObject['FObject_text_' + pzTexts.promize_tab_attribute_id + '_0'].fontFamilyFile;
                pzTextSetting['fontSize'] = _this.props.pzCanvasObject['FObject_text_' + pzTexts.promize_tab_attribute_id + '_0'].fontSize;
                pzTextSetting['fill'] = _this.props.pzCanvasObject['FObject_text_' + pzTexts.promize_tab_attribute_id + '_0'].fill;
                pzTextSetting['textAlign'] = _this.props.pzCanvasObject['FObject_text_' + pzTexts.promize_tab_attribute_id + '_0'].textAlign;
                pzTextSetting['fontWeight'] = _this.props.pzCanvasObject['FObject_text_' + pzTexts.promize_tab_attribute_id + '_0'].fontWeight;
                pzTextSetting['fontStyle'] = _this.props.pzCanvasObject['FObject_text_' + pzTexts.promize_tab_attribute_id + '_0'].fontStyle;
                pzTextSetting['underline'] = _this.props.pzCanvasObject['FObject_text_' + pzTexts.promize_tab_attribute_id + '_0'].underline;
                pzTextSetting['text'] = _this.props.pzCanvasObject['FObject_text_' + pzTexts.promize_tab_attribute_id + '_0'].text;
            }
            return pzTextSetting;
        };

        _this.pzTextProperty = function (textRefId, property, value, pzTextDetail) {
            var fontfile = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';

            var pzObjName = 'FObject_text_' + pzTextDetail.promize_tab_attribute_id + '_0';

            var pzSetting = pzTextDetail.promize_attribute_text_value;
            var repeatCustomizationData = _this.state.repeatCustomizationData;

            var pzObjectParams = {};
            var _this$props = _this.props,
                pzCanvas = _this$props.pzCanvas,
                pzCurrentView = _this$props.pzCurrentView,
                pzCanvasObject = _this$props.pzCanvasObject,
                pzDownloadedModelUrl = _this$props.pzDownloadedModelUrl,
                promizeThreeDObj = _this$props.promizeThreeDObj,
                pzCopyOuterObjKeys = _this$props.pzCopyOuterObjKeys,
                pzCopyInnerObjKeys = _this$props.pzCopyInnerObjKeys,
                pzCopyOuterRepeatObjects = _this$props.pzCopyOuterRepeatObjects,
                pzIsCopyRepeatObjects = _this$props.pzIsCopyRepeatObjects;
            var pzCopyObjectsKeys = _this.props.pzCopyObjectsKeys;

            var pzDefaultProperty = _this.pzDefaultProperties(pzTextDetail);
            var textBoundary = pzTextDetail.boundary_position ? JSON.parse(pzTextDetail.boundary_position) : {};
            //console.log("textBoundary ", textBoundary)


            pzObjectParams = _extends({ boundary: { left: 0, top: 0, scaleX: 1, scaleY: 1, width: 100, height: 100, angle: 0 }, index: 0 }, pzTextDetail, pzDefaultProperty, _this.props.pzTab);
            //pzCreateCanvasObject(this.props.pzCurrentView, 'text', pzObjectParams)
            //console.log(" tet boundary wlaew", pzObjectParams)
            pzObjectParams.property = value;

            var pzObject = {};
            if (pzCanvasObject[pzObjName]) {
                pzObject = pzCanvasObject[pzObjName];
            } else {
                pzObject = _this.props.HomeComponent.pzCreateCartProperties("text", pzObjectParams);
                pzCanvasObject[pzObjName] = _extends({}, pzObject);
            }

            if (property == 'text') {
                pzDefaultProperty['Originaltext'] = value;
            } else if (property == 'fontFamily') {
                pzDefaultProperty['fontFamilyFile'] = fontfile ? fontfile : 'Arial.tiff';
                _this.pzShowFont();
            } else if (property == 'fontSize') {
                _this.pzShowFontSize();
            } else if (property == 'fill') {
                _this.pzShowFontColorForMobile(false);
            } else if (property == 'textAlign') {
                _this.pzShowFontAlignForMobile(false);
            }

            var fontSize = 28,
                fontSpacing = 20;

            if (Object.keys(_this.props.pzAttrTextObj).length > 0 && _this.props.pzAttrTextObj[pzTextDetail.promize_tab_attribute_id]) {
                //console.log("this.props.pzAttrTextObj ", this.props.pzAttrTextObj)
                fontSize = _this.props.pzAttrTextObj[pzTextDetail.promize_tab_attribute_id]['textSize'] ? _this.props.pzAttrTextObj[pzTextDetail.promize_tab_attribute_id]['textSize'] : 20;
                fontSpacing = _this.props.pzAttrTextObj[pzTextDetail.promize_tab_attribute_id]['textSpace'] ? _this.props.pzAttrTextObj[pzTextDetail.promize_tab_attribute_id]['textSpace'] : fontSpacing;
            }

            var fontFamily = _this.state.fontFamily,
                fontWeight = _this.state.fontStyle['fontWeight'],
                fontStyle = _this.state.fontStyle['fontStyle'],
                underline = _this.state.fontStyle['underline'],
                fill = _this.state.settings.background_color;

            if (pzCanvasObject[pzObjName]) {
                var currObj = pzCanvasObject[pzObjName];
                if (currObj.fontFamily != undefined) {
                    fontFamily = currObj.fontFamily;
                }
                if (currObj.fontWeight != undefined) {
                    fontWeight = currObj.fontWeight;
                }
                if (currObj.fontStyle != undefined) {
                    fontStyle = currObj.fontStyle;
                }
                underline = currObj.underline;
                if (currObj.fill != undefined) {
                    fill = currObj.fill;
                }
                pzCanvasObject[pzObjName]['fontFamily'] = fontFamily;
                pzCanvasObject[pzObjName]['fontWeight'] = fontWeight;
                pzCanvasObject[pzObjName]['fontStyle'] = fontStyle;
                pzCanvasObject[pzObjName]['underline'] = underline;
                pzCanvasObject[pzObjName]['fill'] = fill;
            }

            var linkModelAttr = pzTextDetail.link_model_attributes ? JSON.parse(pzTextDetail.link_model_attributes) : '';
            var partNames = {};
            var textPartData = {};
            if (linkModelAttr.length > 0) {
                partNames = linkModelAttr[0].part_names;
                _this.props.HomeComponent.pzTurnModel(partNames[0]);
                partNames && Object.values(partNames).map(function (partName, idx) {
                    // let addText = {}
                    var textObj = {
                        'addText': _defineProperty({}, pzTextDetail.promize_tab_attribute_id, {
                            text: property == "text" ? value : '',
                            properties: {
                                top: 2048,
                                left: 0,
                                fontSize: fontSize,
                                fill: fill,
                                textAlign: 'left',
                                fontFamily: fontFamily,
                                fontWeight: fontWeight,
                                fontStyle: fontStyle,
                                underline: underline,
                                scaleX: 1,
                                scaleY: 1,
                                selectable: false,
                                evented: false,
                                layer: 1
                            }
                        })
                    };
                    textPartData[partName] = {
                        textData: textObj,
                        repeatSettings: {
                            spacing: 0,
                            groupSpacing: 0,
                            objectSpacing: _defineProperty({}, pzTextDetail.promize_tab_attribute_id, fontSpacing)
                        }
                    };
                });
            }
            var currObjKey = pzObject.name;
            pzCanvasObject[currObjKey][property] = value;
            pzCanvasObject[currObjKey]['fontSize'] = fontSize;
            pzCanvasObject[currObjKey]['objectSpacing'] = fontSpacing;
            pzCanvasObject[currObjKey]['partNames'] = [partNames[0]];

            if (!pzCopyOuterRepeatObjects.includes(currObjKey) && (currObjKey.includes(pzCopyOuterObjKeys[0]) || currObjKey.includes(pzCopyOuterObjKeys[1]))) {
                pzCopyOuterRepeatObjects.push(currObjKey);
            }
            if (!pzCopyObjectsKeys.includes(pzObject.name)) {
                pzCopyObjectsKeys.push(pzObject.name);
            }

            if (pzIsCopyRepeatObjects) {
                var objName = currObjKey;
                var name = '';
                var isSameObject = 0,
                    tabAttributeId = 0;

                if (objName.includes(pzCopyOuterObjKeys[0]) || objName.includes(pzCopyOuterObjKeys[1])) {
                    isSameObject = 1;
                } else if (objName.includes(pzCopyInnerObjKeys[0]) || objName.includes(pzCopyInnerObjKeys[1])) {
                    isSameObject = 2;
                }
                if (isSameObject == 1) {
                    if (pzCopyOuterObjKeys[0].includes('text')) {
                        //console.log(pzCopyOuterObjKeys, "pzCopyOuterObjKeys")
                        if (pzCopyInnerObjKeys[0].includes('text')) {
                            name = objName.replace(pzCopyOuterObjKeys[0], pzCopyInnerObjKeys[0]);
                            tabAttributeId = pzCopyInnerObjKeys[0].split('_')[1];
                        } else if (pzCopyInnerObjKeys[1].includes('text')) {
                            name = objName.replace(pzCopyOuterObjKeys[0], pzCopyInnerObjKeys[1]);
                            tabAttributeId = pzCopyInnerObjKeys[1].split('_')[1];
                        }
                    } else if (pzCopyOuterObjKeys[1].includes('text')) {
                        //name = objName.replace(pzCopyOuterObjKeys[0], pzCopyInnerObjKeys[0])
                        //console.log(pzCopyOuterObjKeys, "pzCopyOuterObjKeys one")

                        if (pzCopyInnerObjKeys[0].includes('text')) {
                            name = objName.replace(pzCopyOuterObjKeys[1], pzCopyInnerObjKeys[0]);
                            tabAttributeId = pzCopyInnerObjKeys[0].split('_')[1];
                        } else if (pzCopyInnerObjKeys[1].includes('text')) {
                            name = objName.replace(pzCopyOuterObjKeys[1], pzCopyInnerObjKeys[1]);
                            tabAttributeId = pzCopyInnerObjKeys[1].split('_')[1];
                        }
                    }
                } else if (isSameObject == 2) {
                    if (pzCopyInnerObjKeys[0].includes('text')) {
                        //console.log(pzCopyOuterObjKeys, "pzCopyOuterObjKeys 2")
                        //name = objName.replace(pzCopyInnerObjKeys[0], pzCopyOuterObjKeys[0])
                        if (pzCopyOuterObjKeys[0].includes('text')) {
                            name = objName.replace(pzCopyInnerObjKeys[0], pzCopyOuterObjKeys[0]);
                            tabAttributeId = pzCopyOuterObjKeys[0].split('_')[1];
                        } else if (pzCopyOuterObjKeys[1].includes('text')) {
                            name = objName.replace(pzCopyInnerObjKeys[0], pzCopyOuterObjKeys[1]);
                            tabAttributeId = pzCopyOuterObjKeys[1].split('_')[1];
                        }
                    } else if (pzCopyInnerObjKeys[1].includes('text')) {

                        //console.log(pzCopyOuterObjKeys, "pzCopyOuterObjKeys  2one")
                        //name = objName.replace(pzCopyInnerObjKeys[0], pzCopyOuterObjKeys[0])
                        if (pzCopyOuterObjKeys[0].includes('text')) {
                            name = objName.replace(pzCopyInnerObjKeys[1], pzCopyOuterObjKeys[0]);
                            tabAttributeId = pzCopyOuterObjKeys[0].split('_')[1];
                        } else if (pzCopyOuterObjKeys[1].includes('text')) {
                            name = objName.replace(pzCopyInnerObjKeys[1], pzCopyOuterObjKeys[1]);
                            tabAttributeId = pzCopyOuterObjKeys[1].split('_')[1];
                        }
                    }
                }
                var currPartNames = [partNames[0]];

                if (partNames) {
                    //partNames = linkModelAttr[0].part_names;
                    if (partNames[0] == "outside") {
                        currPartNames[0] = "inside";
                    } else {
                        currPartNames[0] = "outside";
                    }
                }
                pzCanvasObject[name] = {};

                pzCanvasObject[name] = Object.assign({}, pzCanvasObject[currObjKey], { 'partNames': currPartNames });
                pzCanvasObject[name][property] = value;
                pzCanvasObject[name].tabAttrId = tabAttributeId;
                pzCanvasObject[name].name = name;

                textPartData[currPartNames[0]] = {
                    textData: {
                        addText: _defineProperty({}, tabAttributeId, {
                            text: property == "text" ? value : '',
                            properties: {
                                top: 2048,
                                left: 0,
                                fontSize: fontSize,
                                fill: fill,
                                textAlign: 'left',
                                fontFamily: fontFamily,
                                fontWeight: fontWeight,
                                fontStyle: fontStyle,
                                underline: underline,
                                scaleX: 1,
                                scaleY: 1,
                                selectable: false,
                                evented: false,
                                layer: 1
                            }
                        })
                    },
                    repeatSettings: {
                        spacing: 0,
                        groupSpacing: 0,
                        objectSpacing: _defineProperty({}, tabAttributeId, fontSpacing)
                    }
                };

                if (!pzCopyOuterRepeatObjects.includes(name) && (name.includes(pzCopyOuterObjKeys[0]) || name.includes(pzCopyOuterObjKeys[1]))) {
                    pzCopyOuterRepeatObjects.push(name);
                }
                if (!pzCopyObjectsKeys.includes(name)) {
                    pzCopyObjectsKeys.push(name);
                }
            }

            _this.props.HomeComponent.setState({ pzCopyOuterRepeatObjects: pzCopyOuterRepeatObjects, pzCopyObjectsKeys: pzCopyObjectsKeys, pzCanvasObject: pzCanvasObject });

            _this.setState({ inputText: value }, function () {

                /*if (pzIsCopyRepeatObjects) {
                    console.log("%c APPLY2dObjecs", 'background:blue; color:white')
                    this.props.HomeComponent.apply2dObjects();
                   }
                else {*/

                var data3_8 = {
                    name: 'tag_component',
                    component: {
                        name: _this.props.pzBaseType ? _this.props.pzBaseType : '3/4',
                        component: {
                            name: 'tag',
                            customizationData: {
                                repeatData: {
                                    '3d-customization-normal-repeat': textPartData
                                }
                            }
                        }
                    }
                };
                promizeThreeDObj.updateComponent(data3_8);
                //}
            });
        };

        _this.changePickerColor = function (e, selected, attributeDetail) {
            var _this$props2 = _this.props,
                promizeThreeDObj = _this$props2.promizeThreeDObj,
                pzCopyObjectsKeys = _this$props2.pzCopyObjectsKeys,
                pzCopyOuterRepeatObjects = _this$props2.pzCopyOuterRepeatObjects,
                pzCopyInnerObjKeys = _this$props2.pzCopyInnerObjKeys,
                pzCopyOuterObjKeys = _this$props2.pzCopyOuterObjKeys,
                pzCanvasObject = _this$props2.pzCanvasObject,
                pzIsCopyRepeatObjects = _this$props2.pzIsCopyRepeatObjects;
            //console.log("changePickerColor ")

            var pzDefaultProperty = _this.pzDefaultProperties(attributeDetail);
            var pzObjectParams = {};
            pzObjectParams = _extends({ boundary: { left: 0, top: 0, scaleX: 1, scaleY: 1, width: 100, height: 100, angle: 0 }, index: 0 }, attributeDetail, pzDefaultProperty, _this.props.pzTab);

            var pzObjName = 'FObject_text_' + attributeDetail.promize_tab_attribute_id + '_0';
            var pzObject = {};
            if (pzCanvasObject[pzObjName]) {
                pzObject = pzCanvasObject[pzObjName];
            } else {
                pzObject = _this.props.HomeComponent.pzCreateCartProperties("text", pzObjectParams);
            }
            var fontSize = 28,
                fontSpacing = 20;
            if (Object.keys(_this.props.pzAttrTextObj).length > 0 && _this.props.pzAttrTextObj[attributeDetail.promize_tab_attribute_id]) {
                fontSize = _this.props.pzAttrTextObj[attributeDetail.promize_tab_attribute_id]['textSize'];
                fontSpacing = _this.props.pzAttrTextObj[attributeDetail.promize_tab_attribute_id]['textSpace'];
            }
            var partNames = {};
            var textPartData = {};

            if (attributeDetail) {
                var linkModelAttr = attributeDetail.link_model_attributes ? JSON.parse(attributeDetail.link_model_attributes) : '';

                if (linkModelAttr.length > 0) {
                    partNames = linkModelAttr[0].part_names;
                    _this.props.HomeComponent.pzTurnModel(partNames[0]);
                    partNames && Object.values(partNames).map(function (partName, idx) {
                        textPartData[partName] = {
                            textData: {
                                addText: _defineProperty({}, attributeDetail.promize_tab_attribute_id, {
                                    properties: {
                                        fill: selected
                                    }
                                })
                            }
                        };
                    });
                }
                var settings = _this.state.settings;
                settings.background_color = selected;
                var dyesubColor = _this.state.dyesubColor;
                dyesubColor = selected;

                _this.setState({ settings: settings, dyesubColor: dyesubColor }, function () {
                    _this.pzTextDataUpdate(textPartData, partNames, pzObjName, 'fill', selected, attributeDetail);
                });
            }
        };

        _this.pzTextPropertyFontFamily = function (textRefId, property, value, pzTextDetail) {
            _this.pzShowFont();
            var _this$props3 = _this.props,
                promizeThreeDObj = _this$props3.promizeThreeDObj,
                pzCopyObjectsKeys = _this$props3.pzCopyObjectsKeys,
                pzCopyOuterRepeatObjects = _this$props3.pzCopyOuterRepeatObjects,
                pzCopyInnerObjKeys = _this$props3.pzCopyInnerObjKeys,
                pzCopyOuterObjKeys = _this$props3.pzCopyOuterObjKeys,
                pzCanvasObject = _this$props3.pzCanvasObject,
                pzIsCopyRepeatObjects = _this$props3.pzIsCopyRepeatObjects;


            var pzDefaultProperty = _this.pzDefaultProperties(pzTextDetail);
            var pzObjectParams = {};
            pzObjectParams = _extends({ boundary: { left: 0, top: 0, scaleX: 1, scaleY: 1, width: 100, height: 100, angle: 0 }, index: 0 }, pzTextDetail, pzDefaultProperty, _this.props.pzTab);

            //let pzObject = this.props.HomeComponent.pzCreateCartProperties("text", pzObjectParams);

            var pzObjName = 'FObject_text_' + pzTextDetail.promize_tab_attribute_id + '_0';
            var pzObject = {};
            if (pzCanvasObject[pzObjName]) {
                pzObject = pzCanvasObject[pzObjName];
            } else {
                pzObject = _this.props.HomeComponent.pzCreateCartProperties("text", pzObjectParams);
            }
            var fontSize = 28,
                fontSpacing = 20;
            if (Object.keys(_this.props.pzAttrTextObj).length > 0 && _this.props.pzAttrTextObj[pzTextDetail.promize_tab_attribute_id]) {
                fontSize = _this.props.pzAttrTextObj[pzTextDetail.promize_tab_attribute_id]['textSize'];
                fontSpacing = _this.props.pzAttrTextObj[pzTextDetail.promize_tab_attribute_id]['textSpace'];
            }

            var partNames = {};
            var textPartData = {};

            if (pzTextDetail) {
                var linkModelAttr = pzTextDetail.link_model_attributes ? JSON.parse(pzTextDetail.link_model_attributes) : '';

                if (linkModelAttr.length > 0) {
                    partNames = linkModelAttr[0].part_names;
                    _this.props.HomeComponent.pzTurnModel(partNames[0]);
                    partNames && Object.values(partNames).map(function (partName, idx) {
                        textPartData[partName] = {
                            textData: {
                                addText: _defineProperty({}, pzTextDetail.promize_tab_attribute_id, {
                                    properties: {
                                        fontFamily: value
                                    }
                                })
                            },
                            repeatSettings: {
                                spacing: 0,
                                groupSpacing: 0,
                                objectSpacing: _defineProperty({}, pzTextDetail.promize_tab_attribute_id, parseInt(fontSpacing))
                            }

                        };
                    });
                }
                _this.setState({ fontFamily: value }, function () {
                    _this.pzTextDataUpdate(textPartData, partNames, pzObjName, 'fontFamily', value, pzTextDetail);
                });
            }
        };

        _this.pzTextDataUpdate = function (textPartData, partNames, currObjKey, property, propertyValue, pzTextDetail) {
            var _this$props4 = _this.props,
                pzCanvasObject = _this$props4.pzCanvasObject,
                promizeThreeDObj = _this$props4.promizeThreeDObj,
                pzCopyObjectsKeys = _this$props4.pzCopyObjectsKeys,
                pzCopyOuterRepeatObjects = _this$props4.pzCopyOuterRepeatObjects,
                pzCopyInnerObjKeys = _this$props4.pzCopyInnerObjKeys,
                pzCopyOuterObjKeys = _this$props4.pzCopyOuterObjKeys,
                pzIsCopyRepeatObjects = _this$props4.pzIsCopyRepeatObjects,
                pzColorIconClicked = _this$props4.pzColorIconClicked;

            var objName = currObjKey;
            var pzObject = {};
            if (!(currObjKey in pzCanvasObject)) {
                var pzObjectParams = _extends({ boundary: { left: 0, top: 0, scaleX: 1, scaleY: 1, width: 100, height: 100, angle: 0 }, index: 0 }, pzTextDetail, _this.props.pzTab);
                pzObject = _this.props.HomeComponent.pzCreateCartProperties("text", pzObjectParams);
                pzCanvasObject[currObjKey] = _extends({}, pzObject);
            } else {
                pzObject = _extends({}, pzCanvasObject[currObjKey]);
            }
            pzCanvasObject[currObjKey]['partNames'] = [partNames[0]];
            var textProperties = {};
            if (property == 'fill') {

                if (_this.props.pzActiveOptions && Object.keys(_this.props.pzActiveOptions).length > 0) {
                    // Object.keys(props.pzActiveOptions).map((objKey, index) => {
                    for (var objKey in _this.props.pzActiveOptions) {
                        var currActionOptions = _this.props.pzActiveOptions[objKey];
                        var findSilkIdx = currActionOptions.findIndex(function (element) {
                            return typeof element === "string" && element.indexOf('silkscreen') !== -1;
                        });
                        //const findIdxDyesub = currActionOptions.findIndex(element => typeof element === "string" && element.indexOf('dyesub') !== -1);
                        if (findSilkIdx > -1) {
                            pzColorIconClicked = true;
                            break;
                        }
                    }
                }
            }
            if (property != 'fontStyle') {
                pzCanvasObject[currObjKey][property] = propertyValue;
                textProperties[property] = propertyValue;
            } else {
                var fontStyle = propertyValue;
                if (fontStyle['fontWeight']) {
                    pzCanvasObject[currObjKey]['fontWeight'] = fontStyle['fontWeight'];
                    textProperties['fontWeight'] = fontStyle['fontWeight'];
                }
                if (fontStyle['fontStyle']) {
                    pzCanvasObject[currObjKey]['fontStyle'] = fontStyle['fontStyle'];
                    textProperties['fontStyle'] = fontStyle['fontStyle'];
                }
                pzCanvasObject[currObjKey]['underline'] = fontStyle['underline'];
                textProperties['underline'] = fontStyle['underline'];
            }

            if (!pzCopyOuterRepeatObjects.includes(currObjKey) && (currObjKey.includes(pzCopyOuterObjKeys[0]) || currObjKey.includes(pzCopyOuterObjKeys[1]))) {
                pzCopyOuterRepeatObjects.push(currObjKey);
            }
            if (!pzCopyObjectsKeys.includes(pzObject.name)) {
                pzCopyObjectsKeys.push(pzObject.name);
            }

            // for both sides 
            if (pzIsCopyRepeatObjects) {
                var _objName = currObjKey;
                var name = '';
                var isSameObject = 0,
                    tabAttributeId = 0;

                if (_objName.includes(pzCopyOuterObjKeys[0]) || _objName.includes(pzCopyOuterObjKeys[1])) {
                    isSameObject = 1;
                } else if (_objName.includes(pzCopyInnerObjKeys[0]) || _objName.includes(pzCopyInnerObjKeys[1])) {
                    isSameObject = 2;
                }

                if (isSameObject == 1) {
                    if (pzCopyOuterObjKeys[0].includes('text')) {
                        if (pzCopyInnerObjKeys[0].includes('text')) {
                            name = _objName.replace(pzCopyOuterObjKeys[0], pzCopyInnerObjKeys[0]);
                            tabAttributeId = pzCopyInnerObjKeys[0].split('_')[1];
                        } else if (pzCopyInnerObjKeys[1].includes('text')) {
                            name = _objName.replace(pzCopyOuterObjKeys[0], pzCopyInnerObjKeys[1]);
                            tabAttributeId = pzCopyInnerObjKeys[1].split('_')[1];
                        }
                    } else if (pzCopyOuterObjKeys[1].includes('text')) {

                        if (pzCopyInnerObjKeys[0].includes('text')) {
                            name = _objName.replace(pzCopyOuterObjKeys[1], pzCopyInnerObjKeys[0]);
                            tabAttributeId = pzCopyInnerObjKeys[0].split('_')[1];
                        } else if (pzCopyInnerObjKeys[1].includes('text')) {
                            name = _objName.replace(pzCopyOuterObjKeys[1], pzCopyInnerObjKeys[1]);
                            tabAttributeId = pzCopyInnerObjKeys[1].split('_')[1];
                        }
                    }
                } else if (isSameObject == 2) {
                    if (pzCopyInnerObjKeys[0].includes('text')) {
                        if (pzCopyOuterObjKeys[0].includes('text')) {
                            name = _objName.replace(pzCopyInnerObjKeys[0], pzCopyOuterObjKeys[0]);
                            tabAttributeId = pzCopyOuterObjKeys[0].split('_')[1];
                        } else if (pzCopyOuterObjKeys[1].includes('text')) {
                            name = _objName.replace(pzCopyInnerObjKeys[0], pzCopyOuterObjKeys[1]);
                            tabAttributeId = pzCopyOuterObjKeys[1].split('_')[1];
                        }
                    } else if (pzCopyInnerObjKeys[1].includes('text')) {
                        if (pzCopyOuterObjKeys[0].includes('text')) {
                            name = _objName.replace(pzCopyInnerObjKeys[1], pzCopyOuterObjKeys[0]);
                            tabAttributeId = pzCopyOuterObjKeys[0].split('_')[1];
                        } else if (pzCopyOuterObjKeys[1].includes('text')) {
                            name = _objName.replace(pzCopyInnerObjKeys[1], pzCopyOuterObjKeys[1]);
                            tabAttributeId = pzCopyOuterObjKeys[1].split('_')[1];
                        }
                    }
                }

                var currPartNames = [partNames[0]];

                if (partNames) {
                    if (partNames[0] == "outside") {
                        currPartNames[0] = "inside";
                    } else {
                        currPartNames[0] = "outside";
                    }
                }
                pzCanvasObject[name] = {};
                pzCanvasObject[name] = Object.assign({}, pzCanvasObject[currObjKey], { 'partNames': currPartNames });
                pzCanvasObject[name]['name'] = name;
                pzCanvasObject[name]['tabAttrId'] = parseInt(tabAttributeId);

                textPartData[currPartNames[0]] = {
                    textData: {
                        addText: _defineProperty({}, tabAttributeId, {
                            properties: _extends({}, textProperties)
                        })
                    },
                    repeatSettings: {
                        spacing: 0,
                        groupSpacing: 0,
                        objectSpacing: _defineProperty({}, tabAttributeId, parseInt(pzCanvasObject[name]['objectSpacing']))
                    }
                };

                if (!pzCopyOuterRepeatObjects.includes(name) && (name.includes(pzCopyOuterObjKeys[0]) || name.includes(pzCopyOuterObjKeys[1]))) {
                    pzCopyOuterRepeatObjects.push(name);
                }
                if (!pzCopyObjectsKeys.includes(name)) {
                    pzCopyObjectsKeys.push(name);
                }
            }

            _this.props.HomeComponent.setState({
                pzCanvasObject: pzCanvasObject, pzCopyObjectsKeys: pzCopyObjectsKeys, pzCopyOuterRepeatObjects: pzCopyOuterRepeatObjects, pzColorIconClicked: pzColorIconClicked
            });

            /* if (pzIsCopyRepeatObjects) {
                console.log("%c APPLY2dObjecs", 'background:blue; color:white')
                this.props.HomeComponent.apply2dObjects();
            }
            else { */

            var data3_8 = {
                name: 'tag_component',
                component: {
                    name: _this.props.pzBaseType ? _this.props.pzBaseType : '3/4',
                    component: {
                        name: 'tag',
                        customizationData: {
                            repeatData: {
                                '3d-customization-normal-repeat': textPartData
                            }
                        }
                    }
                }
            };
            promizeThreeDObj.updateComponent(data3_8);
            //}
        };

        _this.handleSpacing = function (e) {
            var pzTextDetail = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            var _this$props5 = _this.props,
                promizeThreeDObj = _this$props5.promizeThreeDObj,
                pzCopyObjectsKeys = _this$props5.pzCopyObjectsKeys,
                pzCopyOuterRepeatObjects = _this$props5.pzCopyOuterRepeatObjects,
                pzCopyInnerObjKeys = _this$props5.pzCopyInnerObjKeys,
                pzCopyOuterObjKeys = _this$props5.pzCopyOuterObjKeys,
                pzCanvasObject = _this$props5.pzCanvasObject,
                pzIsCopyRepeatObjects = _this$props5.pzIsCopyRepeatObjects;


            var pzDefaultProperty = _this.pzDefaultProperties(pzTextDetail);
            var pzObjectParams = {};
            pzObjectParams = _extends({ boundary: { left: 0, top: 0, scaleX: 1, scaleY: 1, width: 100, height: 100, angle: 0 }, index: 0 }, pzTextDetail, pzDefaultProperty, _this.props.pzTab);

            var pzObject = _this.props.HomeComponent.pzCreateCartProperties("text", pzObjectParams);
            var partNames = {};
            var textPartData = {};

            if (pzTextDetail) {

                var linkModelAttr = pzTextDetail.link_model_attributes ? JSON.parse(pzTextDetail.link_model_attributes) : '';

                if (linkModelAttr.length > 0) {
                    partNames = linkModelAttr[0].part_names;
                    partNames && Object.values(partNames).map(function (partName, idx) {

                        textPartData[partName] = {
                            repeatSettings: {
                                spacing: 0,
                                groupSpacing: 0,
                                objectSpacing: _defineProperty({}, pzTextDetail.promize_tab_attribute_id, parseInt(e.target.value))
                            }
                        };
                    });
                }
            }

            _this.pzTextUpdateData(textPartData, partNames, pzObject, 'sliderValue', e.target.value, 'left');
        };

        _this.pzTextStyle = function (pzTextDetail) {
            var _this$props6 = _this.props,
                promizeThreeDObj = _this$props6.promizeThreeDObj,
                pzCopyObjectsKeys = _this$props6.pzCopyObjectsKeys,
                pzCopyOuterRepeatObjects = _this$props6.pzCopyOuterRepeatObjects,
                pzCopyInnerObjKeys = _this$props6.pzCopyInnerObjKeys,
                pzCopyOuterObjKeys = _this$props6.pzCopyOuterObjKeys,
                pzCanvasObject = _this$props6.pzCanvasObject,
                pzIsCopyRepeatObjects = _this$props6.pzIsCopyRepeatObjects;


            var pzDefaultProperty = _this.pzDefaultProperties(pzTextDetail);
            var pzObjectParams = {};
            pzObjectParams = _extends({ boundary: { left: 0, top: 0, scaleX: 1, scaleY: 1, width: 100, height: 100, angle: 0 }, index: 0 }, pzTextDetail, pzDefaultProperty, _this.props.pzTab);

            var pzObjName = 'FObject_text_' + pzTextDetail.promize_tab_attribute_id + '_0';
            var pzObject = {};
            if (pzCanvasObject[pzObjName]) {
                pzObject = pzCanvasObject[pzObjName];
            } else {
                pzObject = _this.props.HomeComponent.pzCreateCartProperties("text", pzObjectParams);
            }
            var fontSize = 28,
                fontSpacing = 20;
            if (Object.keys(_this.props.pzAttrTextObj).length > 0 && _this.props.pzAttrTextObj[pzTextDetail.promize_tab_attribute_id]) {
                fontSize = _this.props.pzAttrTextObj[pzTextDetail.promize_tab_attribute_id]['textSize'];
                fontSpacing = _this.props.pzAttrTextObj[pzTextDetail.promize_tab_attribute_id]['textSpace'];
            }

            var fontStyle = _extends({}, _this.state.fontStyle);
            var textProperties = {};
            if (fontStyle['fontWeight']) {
                textProperties['fontWeight'] = fontStyle['fontWeight'];
            }
            if (fontStyle['fontStyle']) {
                textProperties['fontStyle'] = fontStyle['fontStyle'];
            }
            //if (fontStyle['underline']) {
            textProperties['underline'] = fontStyle['underline'];
            //}


            var partNames = {};
            var textPartData = {};

            if (pzTextDetail) {
                var linkModelAttr = pzTextDetail.link_model_attributes ? JSON.parse(pzTextDetail.link_model_attributes) : '';

                if (linkModelAttr.length > 0) {
                    partNames = linkModelAttr[0].part_names;
                    _this.props.HomeComponent.pzTurnModel(partNames[0]);
                    partNames && Object.values(partNames).map(function (partName, idx) {
                        textPartData[partName] = {
                            textData: {
                                addText: _defineProperty({}, pzTextDetail.promize_tab_attribute_id, {
                                    properties: _extends({}, textProperties)
                                })
                            },
                            repeatSettings: {
                                spacing: 0,
                                groupSpacing: 0,
                                objectSpacing: _defineProperty({}, pzTextDetail.promize_tab_attribute_id, parseInt(fontSpacing))
                            }

                        };
                    });
                }
                _this.pzTextDataUpdate(textPartData, partNames, pzObjName, 'fontStyle', _this.state.fontStyle, pzTextDetail);
            }
        };

        _this.pzTextPropertySize = function (textRefId, property, value, pzTextDetail) {
            _this.pzShowFontSize();

            //console.log(property, value)
            _this.setState({ fontSize: value }, function () {
                var promizeThreeDObj = _this.props.promizeThreeDObj;


                var partNames = {};
                var textPartData = {};

                if (pzTextDetail) {
                    var linkModelAttr = pzTextDetail.link_model_attributes ? JSON.parse(pzTextDetail.link_model_attributes) : '';

                    if (linkModelAttr.length > 0) {
                        partNames = linkModelAttr[0].part_names;
                        partNames && Object.values(partNames).map(function (partName, idx) {

                            textPartData[partName] = {
                                text: {
                                    addText: _defineProperty({}, pzTextDetail.promize_tab_attribute_id, {
                                        text: 'sample text',
                                        properties: {
                                            fontSize: parseInt(value)
                                        }
                                    })
                                },
                                repeatSettings: {
                                    spacing: 0,
                                    groupSpacing: 0,
                                    objectSpacing: _defineProperty({}, pzTextDetail.promize_tab_attribute_id, parseInt(_this.state.sliderValue))
                                }
                            };
                        });

                        var data3_8 = {
                            name: 'tag_component',
                            component: {
                                name: _this.props.pzBaseType ? _this.props.pzBaseType : '3/4',
                                component: {
                                    name: 'tag',
                                    customizationData: {
                                        upload: [{}],
                                        repeatData: {
                                            '3d-customization-normal-repeat': textPartData
                                        }
                                    }
                                }
                            }
                        };
                        promizeThreeDObj.updateComponent(data3_8);
                    }
                }
            });
        };

        _this.pzTextView = function (textRefId, pzTextDetail) {
            // console.log('test etes tsetset', pzTextDetail)

            // this.props.HomeComponent.setState({ "pzCurrentView": viewIndex },()=>{
            //     this.props.HomeComponent.pzReloadCanvasObjects();
            // })
        };

        _this.pzLeftPosition = function (textboundary, textwidth) {
            return parseFloat(textboundary.left) + parseFloat(textboundary.width) / 2 - parseFloat(textwidth) / 2;
        };

        _this.pzShowFont = function () {
            _this.setState({ showFont: !_this.state.showFont });
        };

        _this.pzShowFontSize = function () {
            _this.setState({ showFontSize: !_this.state.showFontSize });
        };

        _this.pzShowFontColorForMobile = function (status) {
            _this.setState({ showFontColorForMobile: status });
        };

        _this.pzShowFontAlignForMobile = function (status) {
            _this.setState({ showFontAlignForMobile: status });
        };

        _this.pzShowFontStyleForMobile = function (status) {
            _this.setState({ showFontStyleForMobile: status });
        };

        _this.pzTextShapes = function (textRefId, property, value, pzTextDetail) {
            //console.log("property ", property, " value ", value)
            var fontStyle = _extends({}, _this.state.fontStyle);
            //console.log("fontStyle ", fontStyle)
            var pzDefaultProperty = _this.pzDefaultProperties(pzTextDetail);
            if (value == 'bold') {
                property = 'fontWeight';
                value = fontStyle['fontWeight'].toLowerCase() == 'bold' ? 'normal' : 'bold';
            } else if (value == 'italic') {
                property = 'fontStyle';
                value = fontStyle['fontStyle'].toLowerCase() == 'italic' ? 'normal' : 'italic';
            } else if (value == 'underline') {
                property = 'underline';
                // textProperty[textRefId][value] = (pzDefaultProperty['fontWeight'] == 'underline') ? 'no' : 'yes';
                value = fontStyle['underline'] == true ? false : true;
            }
            //console.log(property, value)
            fontStyle[property] = value;
            _this.pzShowFontStyleForMobile(false);
            _this.setState({ fontStyle: fontStyle }, function () {
                _this.pzTextStyle(pzTextDetail);
            });
        };

        _this.pzShowTopFonts = function (e) {
            var showTopFonts = _this.state.showTopFonts;
            _this.setState({ showTopFonts: showTopFonts == 5 ? 'all' : 5 });
        };

        _this.handleSSamplepacing = function (e) {

            var control = e.target,
                controlMin = control.getAttribute('min'),
                controlMax = control.getAttribute('max'),
                controlVal = control.value,
                controlThumbWidth = control.getAttribute('data-thumbwidth');

            var range = controlMax - controlMin;

            var position = (controlVal - controlMin) / range * 100;
            var positionOffset = Math.round(controlThumbWidth * position / 100) - controlThumbWidth / 2;
            var output = control.nextElementSibling;
            //console.log('calc(' + position + '% - ' + positionOffset + 'px)')
            //console.log(controlVal);

            _this.setState({ showSampleSliderData: { 'value': controlVal, style: 'left:calc(' + position + '% - ' + positionOffset + 'px)' } });

            /* 
            
                    output
                        .css('left', 'calc(' + position + '% - ' + positionOffset + 'px)')
                        .text(controlVal); */
        };

        _this.pzTextSwitchModel = function (e, pzTextDetail) {
            if (pzTextDetail) {
                var linkModelAttr = pzTextDetail.link_model_attributes ? JSON.parse(pzTextDetail.link_model_attributes) : '';
                if (linkModelAttr.length > 0) {
                    var partNames = linkModelAttr[0].part_names;
                    _this.props.HomeComponent.pzTurnModel(partNames[0], true);
                }
            }
        };

        _this.state = {
            textProperty: { 1: { 'fontWeight': 'normal', 'fontStyle': 'normal', 'textDecoration': 'none' } },
            showBoundary: 0,
            showSelectBoundary: 1,
            textselectable: true,
            textBoundaryControls: true,
            settings: {
                background_color: '#FFFFFF'
            },
            dyesubColor: '#000000',
            textCenterBoundary: 1,
            sliderValue: 20,
            inputText: "",
            fontSize: 28,
            fontFamily: 'Arial',
            fontStyle: { 'fontWeight': 'normal', 'fontStyle': 'normal', 'underline': false },
            showFont: false,
            showFontSize: false,
            showFontColorForMobile: false,
            showFontStyleForMobile: false,
            showFontAlignForMobile: false,
            showTopFonts: 5,
            showSampleSliderData: {}
        }, _this.cloneCount = 1;
        return _this;
    }

    _createClass(PromizeText, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            // var textProperty = (this.state.textProperty) ? this.state.textProperty : {};
            // textProperty[1] = { 'fontWeight': 'normal', 'fontStyle': 'normal', 'textDecoration': 'none' }
            // this.setState({ textProperty });
            // var pzDomainText = this.props.pzCustomizer.attributeDomainTexts;
            // var pzSetting = this.props.pzTexts.promize_attribute_text_value;
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            document.addEventListener('mousedown', this.handleClickOutside);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            document.removeEventListener('mousedown', this.handleClickOutside);
        }
    }, {
        key: 'pzChangeTextState',
        value: function pzChangeTextState(property) {
            if (property == 'fontSize' || property == 'fontFamily') {
                property == 'fontSize' ? this.setState({ 'showFontSize': '' }) : this.setState({ 'showFont': '' });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var pzTexts = this.props.pzTexts;
            var pzTextDetail = pzTexts.promize_attribute_text_value;
            var pzTextSetting = [];
            var textSetting = this.props.pzCustomizer.attributeDomainTexts;
            var currentView = this.props.pzCurrentView;
            pzTextSetting = this.pzDefaultProperties(pzTexts);
            return React.createElement(
                React.Fragment,
                null,
                React.createElement(PZText, _extends({
                    TextComponent: this }, this.props, {
                    commonTextSetting: this.props.pzCustomizer.attributeDomainTexts
                }, this.state, {
                    textComponent: this,
                    changePickerColor: this.changePickerColor,
                    pzTextPropertySize: this.pzTextPropertySize,
                    pzTextPropertyFontFamily: this.pzTextPropertyFontFamily,
                    textSetting: pzTextSetting,
                    handleSpacing: this.handleSpacing,
                    pzShowTopFonts: this.pzShowTopFonts,
                    handleSSamplepacing: this.handleSSamplepacing
                }))
            );
        }
    }]);

    return PromizeText;
}(React.Component);